import {mapActions, mapGetters, mapMutations} from 'vuex'
import _ from 'lodash';

import breadcrumbs from '@/components/breadcrumbs/index.vue'
import dashboardTable from './table/index.vue'

export default {
  name: 'dashboard',
  //---components
  components: {
    breadcrumbs,
    dashboardTable
  },
  //---data
  data () {
    return {
      togglers: {
        isDataLoaded: false
      }
    }
  },
  //---hooks
  created: function () {
    this.loaderFlag(true)
    let requestTypes = [0,1,2],
        promiseCollection = [];

    requestTypes.forEach((requestType,index) => {
      let listMeta = _.cloneDeep(this.dashboardListMeta);
      listMeta.list[index].pageId = 1;
      if (index !== 0 && listMeta.list[index].params[0].val === undefined) {
        listMeta.list[index].params[0].val = (localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).external_user_id : null;
      }
      this.setDashboardListMeta(listMeta);
      promiseCollection.push(this.getDashboardList({typeId: requestType}));
    });

    if (this.dashboardRealtyList === null) {
      promiseCollection.push(this.getDashboardRealtyList());
    }

    if (this.dashboardAnalystList === null) {
      promiseCollection.push(this.getDashboardAnalystList());
    }

    Promise.all(promiseCollection).finally(()=>{
      this.togglers.isDataLoaded = true;
      this.loaderFlag(false)
    });

  },
  computed: {
    ...mapGetters({
      dashboardLists: 'DASHBOARD/dashboardLists',
      dashboardListMeta: 'DASHBOARD/dashboardListMeta',
      dashboardRealtyList: 'DASHBOARD/dashboardRealtyList',
      dashboardAnalystList: 'DASHBOARD/dashboardAnalystList',
    })
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      setDashboardListMeta: 'DASHBOARD/DASHBOARD_LIST_META_SET',
    }),
    ...mapActions({
      getDashboardList: 'DASHBOARD/DASHBOARD_LIST_REQUEST_GET',
      getDashboardRealtyList: 'DASHBOARD/DASHBOARD_REALTY_LIST_REQUEST_GET',
      getDashboardAnalystList: 'DASHBOARD/DASHBOARD_ANALYST_LIST_REQUEST_GET',
    }),
  }
}